import FeaturedSlider from "@/components/FeaturedSlider";
import MostRecentSlider from "@/components/MostRecentSlider";
import LatestPostsWidget from "@/components/LatestPostsWidget";
import VideoEmbedBlock from "@/components/VideoEmbedBlock";
import Sidebar from "@/components/Sidebar";
import HeroSlider from "@/components/HeroSlider";
import MarqueeBanner from "@/components/MarqueeBanner";

export default function MainPage() {
    return (
        <div data-testid="main-page">
            <HeroSlider />
            <MarqueeBanner />

            <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 px-4 md:px-8 lg:px-12 mt-12">
                <div className="lg:col-span-8">
                    <FeaturedSlider />
                    <MostRecentSlider />
                    <div className="mt-16" data-testid="main-latest-posts-wrap">
                        <LatestPostsWidget layout="main" limit={8} />
                    </div>
                    <VideoEmbedBlock />
                </div>
                <div className="lg:col-span-4 lg:pt-12">
                    <Sidebar variant="ads-events" />
                </div>
            </div>
        </div>
    );
}
